import { createSlice } from "@reduxjs/toolkit";

const uploadSlice = createSlice({
  name: "upload",
  initialState: {
    summary: null,
  },
  reducers: {
    setUploadSummary: (state, action) => {
      state.summary = action.payload;
    },
    clearUploadSummary: (state) => {
      state.summary = null;
    },
  },
});

export const { setUploadSummary, clearUploadSummary } = uploadSlice.actions;
export default uploadSlice.reducer;